'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTrendingDown = function ActionTrendingDown(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z' })
  );
};
ActionTrendingDown = (0, _pure2.default)(ActionTrendingDown);
ActionTrendingDown.displayName = 'ActionTrendingDown';
ActionTrendingDown.muiName = 'SvgIcon';

exports.default = ActionTrendingDown;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/action/trending-down.js
 ** module id = 1612
 ** module chunks = 0
 **/